'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import { clsx } from 'clsx'
import { ListingItem } from '@/app/listings/components/Main/ListingItem'
import { useRecommendedListingsQuery, Size, Condition, Color } from '@/api'
import 'swiper/css'
import 'swiper/css/pagination'

interface RecommendedItemsProps {
  listingUuid: string
  limit?: number
}

export const RecommendedItems: React.FC<RecommendedItemsProps> = ({
  listingUuid,
  limit = 8,
}) => {
  const { data } = useRecommendedListingsQuery({
    variables: {
      listingUuid,
      limit,
    },
    skip: !listingUuid,
    fetchPolicy: 'cache-and-network',
  })

  const recommendedListings = data?.recommendedListings ?? []

  if (recommendedListings.length === 0) return null

  return (
    <div className="relative">
      <Swiper
        breakpoints={{
          768: {
            slidesPerView: 4.2,
            spaceBetween: 2,
          },
        }}
        modules={[Navigation, Pagination]}
        slidesPerView={2}
        spaceBetween={2}
        navigation={{
          prevEl: '#recommended_button_prev',
          nextEl: '#recommended_button_next',
        }}
        pagination={{
          clickable: true,
          el: '.recommended-pagination',
        }}
        loop={recommendedListings.length > 4}
        className="select-none lg:pb-0"
      >
        {recommendedListings.map((listing) => (
          <SwiperSlide key={listing.id}>
            <ListingItem
              key={listing.id}
              uuid={listing.uuid}
              title={listing.product?.productMaster?.name || ''}
              listingPrice={listing.price || 0}
              originalPrice={listing.product?.productMaster?.price || undefined}
              image={listing.images?.[0]}
              images={listing.images || undefined}
              size={listing.size as Size}
              condition={listing.condition as Condition}
              color={listing.product?.color as Color}
              sex={listing.product?.productMaster?.sex}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <span
        id="recommended_button_prev"
        className={clsx(
          'hidden  w-3 h-3 md:w-6 md:h-6 cursor-pointer absolute top-[43%] -translate-y-2/4 left-[-2vw] z-10 -rotate-45 md:flex items-center justify-center bg-transparent border-t-[6px] border-l-[6px] border-[#939393]'
        )}
      ></span>
      <span
        id="recommended_button_next"
        className={clsx(
          'hidden w-3 h-3 md:w-6 md:h-6 cursor-pointer absolute top-[43%] -translate-y-2/4 right-[-2vw] z-10 rotate-45 md:flex items-center justify-center bg-transparent border-t-[6px] border-r-[6px] border-[#939393]'
        )}
      ></span>
      {/* Pagination (モバイルのみ) */}
      <div className="recommended-pagination lg:hidden flex justify-center gap-3"></div>
    </div>
  )
}
